import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { t } from 'i18next';
import { Controller, useFormContext } from 'react-hook-form';

export const GuideCertifiedSection = () => {
  const formMethods = useFormContext<{
    guide_certified: boolean;
    guide_certification_date: dayjs.Dayjs;
  }>();
  const { control, watch } = formMethods;
  const isGuideCertified = watch('guide_certified');

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexDirection: 'row',
        gap: '0.5rem',
      }}
    >
      <Box
        sx={{
          width: '50%',
        }}
      >
        <Typography
          sx={{
            fontWeight: 'regular',
            fontSize: '0.75rem',
            opacity: '60%',
            letterSpacing: '0.4px',
            color: 'text.primary',
          }}
        >
          {t('adminPanel.providers.addModal.checkboxDescr')}
        </Typography>
        <Controller
          control={control}
          name='guide_certified'
          defaultValue={false}
          render={({ field: { onChange, value } }) => (
            <FormControlLabel
              control={<Checkbox checked={value} onChange={onChange} />}
              label={t('adminPanel.providers.addModal.licenses.guideCertified')}
            />
          )}
        />
      </Box>
      <Box
        sx={{
          width: '50%',
        }}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Controller
            control={control}
            name='guide_certification_date'
            rules={{ required: true }}
            render={({ field }) => {
              return (
                <DatePicker
                  disabled={!isGuideCertified}
                  label={t(
                    'adminPanel.providers.addModal.licenses.certificationDate',
                  )}
                  name={field.name}
                  value={field.value}
                  inputRef={field.ref}
                  onChange={date => {
                    field.onChange(dayjs(date));
                  }}
                />
              );
            }}
          />
        </LocalizationProvider>
      </Box>
    </Box>
  );
};
